import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear local storage token (or dispatch your logout action)
    localStorage.removeItem("token");
    sessionStorage.removeItem("tempPassword");

    // Redirect to login
    navigate("/login");
  }, [navigate]);

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100vh" }}
    >
      <div className="text-center">
        <h4>Logging out...</h4>
        <p>Please wait while we sign you out.</p>
      </div>
    </div>
  );
};

export default Logout;
